import * as c from "./constant";

function merchants(state = [], action) {
  switch (action.type) {
    case c.SET_MERCHANTS:
      return [...action.payload];
    default:
      return state;
  }
}

function merchantValidation(state = { isRequired: false }, action) {
  switch (action.type) {
    case c.SET_MERCHANT_REQUIRED:
      return { ...state, isRequired: action.payload };
    default:
      return state;
  }
}

export { merchants, merchantValidation };
